<template>
  <div id="auswertung_user">
    <div class="row">
      <div class="col-12">
        <table class="table">
          <thead>
          <tr>
            <th v-for="k in title" :key="'title' + k">{{ k }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="dat in data" :key="'data' + dat.USERNAME">
            <td v-for="d in dat" :key="'subdata' + dat.USERNAME + d">{{ d }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b>Kommentare:</b>
        <ul>
          <li v-for="k in kommentare" :key="'kommentar' + k">{{ k.KOMMENTAR }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  import config from '../config'

  export default {
    props: ['land'],
    watch: {
      auswertung() {
        this.getData();
      }
    },
    data () {
      return {
        title: [],
        data: [],
        kommentare: [],
        auswertung: 'detail'
      }
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        let token = this.$store.state.token;
        axios.get(config.apiServerAdress + '/'+this.auswertung+'/'+this.land, {headers: {'x-access-token': token}})
          .then(res => {
            const data = res.data;
            const rank = [];
            const keys = [];

            for (let key in data) {
              const r = data[key];
              rank.push(r);
            }

            for (let k in rank[0]) {
              keys.push(k);
            }

            this.data = rank;
            this.title = keys;
          })
          .catch(error => {
            console.log(error);
          });

        axios.get(config.apiServerAdress + '/kommentare/'+this.land, {headers: {'x-access-token': token}})
          .then(res => {
            const data = res.data;
            const komm = [];

            for (let key in data) {
              const r = data[key];
              komm.push(r);
            }

            this.kommentare = komm;
          })
          .catch(error => {
            console.log(error);
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
